/** @file requireNode: a puppet node by name, or NOT_FOUND at the given input path. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Puppet, PuppetNode } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** The node `name` of `puppet`; `NOT_FOUND` at `path` (hint: a few node names) when it has none. */
export function requireNode(puppet: Pick<Puppet, 'nodes'>, name: string, path: string): PuppetNode {
  const node = puppet.nodes[name];
  if (node !== undefined) return node;
  return throwError(ERROR_CODES.NOT_FOUND, { node: name }, { path, hint: `nodes: ${Object.keys(puppet.nodes).slice(0, 12).join(', ')}` });
}
